import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    TextField,
    Typography,
    Tabs,
    Tab,
    Checkbox,
    List,
    ListItem,
    ListItemText,
    Collapse,
    IconButton
} from "@mui/material";
import { inputStyle, labelStyle } from "../../../../components/form/formInput";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { IOSSwitch } from "../../../../components/switch/IOSSwitch";
import Autocomplete from "@mui/material/Autocomplete";
import CustomButton from "../../../../components/custom-button/customButton";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
    getAllClinicsBusinessHours,
    getAllStaffBreakTime,
    getAllStaffHolidays,
    getStaffSchedule,
    storeStaffSchedule
} from "../../../../store/clinics/clinicSettings/business-hours";
import * as yup from "yup";
import { useFormik } from "formik";
import StaffHoliday from "./staffHoliday";
import StaffBreakTime from "./staffBreakTime";
import Waveloading from '../../../loading/Waveloading';
import FormInput from "../../../../components/form/formInput";
import SubmitButton from "../../../../components/custom-button/submitButton";
import FormPasswordInput from "../../../../components/form/formPasswordInput";
import Image from "../../../../components/image/image";
import { getAllClinicsServices } from "../../../../store/clinics/clinicSettings/clinics-services";
import {
    getClinicsStaffByID,
    storeClinicsStaff,
    updateClinicsStaff
} from "../../../../store/clinics/clinicSettings/clinic-staff";
import FormAutoComplete from "../../../../components/form/FormAutoComplete";
import FormInputPhone from "../../../../components/form/formInputPhone";
import { HexColorPicker } from 'react-colorful';
import CustomModal from "../../../../components/modal/customModal";
import menuStore, { getAllMenus as fetchAllMenus } from "../../../../store/menus";
import { getAllClinicsStaffTreatmentGroup } from "../../../../store/clinics/clinicSettings/clinic-treatment-group";
import FormAutoParentChild from "../../../../components/form/FormAutoParentChild";
import FormStatusInput from "../../../../components/form/FormStatusInput";
import { generateTimeArray, parseTime, timeSlots } from "../../../../services/utills";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import * as Yup from "yup";

const AddStaff = () => {
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [expandedCategories, setExpandedCategories] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    // Selectors
    const clinicsBusinessHoursStore = useSelector(state => state.clinicsBusinessHoursStore);
    const clinicServicesStore = useSelector(state => state?.clinicServicesStore);
    const clinicTreatmentGroupStore = useSelector(state => state?.clinicTreatmentGroupStore);
    const user = useSelector(state => state?.authStore?.user);
    const menus = useSelector(state => state.menuStore.menus);
    const { businessHours, staffHours, staffHolidays, staffBreakTimes } = clinicsBusinessHoursStore;

    // Staff Details Form
    const staffDetailsValidationSchema = yup.object({
        name: yup.string().required("Name is required"),
        color: yup.string().required("Color is required"),
        email: yup.string().email("Invalid email format").required("Email is required"),
        phone: Yup.string()
            .required('Phone number is required')
            .test(
                'no-alphabets',
                'Phone number is not valid',
                (value) => !/[a-zA-Z]/.test(value)
            ),
        countryCode: yup.string().required("Country code is required"),
    });

    const staffDetailsFormik = useFormik({
        initialValues: {
            name: "",
            email: "",
            color: "#463434",
            phone: "",
            countryCode: "+1",
            job_role: "",
           // service_ids: [],
            category_ids: [],
            menu_ids: [],
            password: "",
            staff_show_all_calendar: 0,
            is_allow_full_calendar: 0,
            is_allow_all_notes: 0,
            is_reception: 0,
            profile_image: null
        },
        validationSchema: staffDetailsValidationSchema,
        onSubmit: async (data) => {
            setLoading(true);
            const formData = new FormData();
            Object.keys(data).forEach(function (key, index) {
                if (Array.isArray(data[key])) {
                    data[key].forEach(value => formData.append(key + '[]', value?.id));
                } else {
                    if (key === "profile_image") {
                        if (typeof data[key] !== 'string') {
                            formData.append(key, data[key]);
                        }
                    } else if (key === 'countryCode' || key === 'phone') {
                        formData.append(key, data["countryCode"] + data["phone"]);
                    } else {
                        formData.append(key, data[key]);
                    }
                }
            });
            formData.append("provider_id", params?.clinic_id);
            let res;
            if (params?.staff_id) {
                res = await dispatch(updateClinicsStaff({ data: formData, provider_id: params?.clinic_id }));
            } else {
                res = await dispatch(storeClinicsStaff({ data: formData, provider_id: params?.clinic_id }));
            }

            if (res?.payload) {
                if (res?.payload?.success === 'true') {
                    navigate(`/${user?.role_id === 2 ? "crm" : "admin"}/configuration/clinic/${params?.clinic_id}/staff`);
                }
                if (res?.payload?.errors) {
                    const errors = res?.payload?.errors;
                    Object.keys(errors).forEach(function (key) {
                        staffDetailsFormik.setFieldTouched(key, true);
                        staffDetailsFormik.setFieldError(key, errors[key]);
                    });
                }
            }
            setLoading(false);
        },
    });

    // Working Hours Form
    const workingHoursValidationSchema = yup.object({
        hours: yup.array().of(
            yup.object().shape({
                is_off: yup.boolean().required("Is day off is required"),
                start_time: yup
                    .date()
                    .transform((value, originalValue) =>
                        originalValue ? parseTime(originalValue) : null
                    ),
                end_time: yup
                    .date()
                    .transform((value, originalValue) =>
                        originalValue ? parseTime(originalValue) : null
                    )
                    .min(yup.ref("start_time"), "End time must be after start time"),
            })
        ),
    });

    const workingHoursFormik = useFormik({
        initialValues: {
            hours: [
                { day: 'Sunday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Monday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Tuesday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Wednesday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Thursday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Friday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
                { day: 'Saturday', is_off: true, start_time: "", end_time: "", per_day_appointments: 1 },
            ],
        },
        validationSchema: workingHoursValidationSchema,
        onSubmit: async (data) => {
            setLoading(true);
            let res = await dispatch(storeStaffSchedule({
                hours: data?.hours,
                provider_id: params?.clinic_id,
                staff_id: params?.staff_id
            }));

            if (res?.payload?.success === "true") {
                // Success handling
            }
            if (res?.payload?.errors) {
                const { errors } = res?.payload;
                Object.keys(errors).forEach(function (key) {
                    workingHoursFormik.setFieldTouched(key, true);
                    workingHoursFormik.setFieldError(key, errors[key]);
                });
            }
            setLoading(false);
        },
    });

    // Helper functions
    const createTimeSlots = (day) => {
        if (businessHours) {
            const sourceObject = businessHours.find((sourceObject) => sourceObject.day === day);
            const start_time = sourceObject?.start_time;
            const end_time = sourceObject?.end_time;

            if (start_time && end_time) {
                return generateTimeArray(start_time, end_time);
            } else {
                return timeSlots;
            }
        } else {
            return timeSlots;
        }
    };

    // Toggle category expansion
    const handleToggleCategory = (categoryId) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    };

    // Handle category selection
// Handle category selection with automatic child selection
    const handleCategoryToggle = (category) => {
        const currentIndex = staffDetailsFormik.values.category_ids.findIndex(
            (cat) => cat.id === category.id
        );
        const newChecked = [...staffDetailsFormik.values.category_ids];

        if (currentIndex === -1) {
            // Add the category and all its children
            newChecked.push(category);
            if (category.child && category.child.length > 0) {
                const addChildren = (children) => {
                    children.forEach(child => {
                        if (!newChecked.some(cat => cat.id === child.id)) {
                            newChecked.push(child);
                        }
                        if (child.child && child.child.length > 0) {
                            addChildren(child.child);
                        }
                    });
                };
                addChildren(category.child);
            }
        } else {
            // Remove the category and all its children
            newChecked.splice(currentIndex, 1);
            if (category.child && category.child.length > 0) {
                const removeChildren = (children) => {
                    children.forEach(child => {
                        const childIndex = newChecked.findIndex(cat => cat.id === child.id);
                        if (childIndex !== -1) {
                            newChecked.splice(childIndex, 1);
                        }
                        if (child.child && child.child.length > 0) {
                            removeChildren(child.child);
                        }
                    });
                };
                removeChildren(category.child);
            }
        }

        staffDetailsFormik.setFieldValue('category_ids', newChecked);
    };

// Check if a parent category should be partially checked (some but not all children selected)
    // Fix the isCategoryIndeterminate function
    const isCategoryIndeterminate = (category) => {
        if (!category.child || category.child.length === 0) return false;

        const selectedChildren = category.child.filter(child =>
            staffDetailsFormik.values.category_ids.some(cat => cat.id === child.id)
        );

        return selectedChildren.length > 0 && selectedChildren.length < category.child.length;
    };
    // Render hierarchical categories
    const renderCategories = (categories, level = 0) => {
        return categories.map((category) => (
            <React.Fragment key={category.id}>
                <ListItem sx={{ pl: level * 4 }}>
                    {category.child && category.child.length > 0 ? (
                        <Box onClick={() => handleToggleCategory(category.id)} sx={{ cursor: 'pointer',marginRight: "10px", }}>
                            {expandedCategories[category.id] ? <ExpandLess /> : <ExpandMore />}
                        </Box>
                    ) : (
                        <Box sx={{ width: 24 }} /> // Empty space for alignment
                    )}
                    <Checkbox
                        edge="start"
                        checked={staffDetailsFormik.values.category_ids.some(cat => cat.id === category.id)}
                        indeterminate={isCategoryIndeterminate(category)}
                        tabIndex={-1}
                        disableRipple
                        onChange={() => handleCategoryToggle(category)}
                    />
                    <ListItemText primary={category.title} />
                </ListItem>
                {category.child && category.child.length > 0 && (
                    <Collapse in={expandedCategories[category.id]} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {renderCategories(category.child, level + 1)}
                        </List>
                    </Collapse>
                )}
            </React.Fragment>
        ));
    };

    // Initial data loading
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await dispatch(getAllClinicsServices({ provider_id: params.clinic_id }));
            await dispatch(getAllClinicsStaffTreatmentGroup(params.clinic_id));
            await dispatch(fetchAllMenus());

            if (params?.staff_id) {
                await dispatch(getAllClinicsBusinessHours(params?.clinic_id));
                await dispatch(getStaffSchedule({ provider_id: params?.clinic_id, staff_id: params?.staff_id }));
                await dispatch(getAllStaffHolidays({ provider_id: params?.clinic_id, staff_id: params?.staff_id }));
                await dispatch(getAllStaffBreakTime({ provider_id: params?.clinic_id, staff_id: params?.staff_id }));
            }
            setLoading(false);
        };
        fetchData();
    }, [dispatch, params.clinic_id, params.staff_id]);

    // Set staff details when data loads
    useEffect(() => {
        const fetchStaffData = async () => {
            if (params?.staff_id) {
                try {
                    const res = await dispatch(getClinicsStaffByID({
                        provider_id: params?.clinic_id,
                        id: params?.staff_id
                    }));

                    if (res?.payload?.data?.id) {
                        const staffData = res?.payload?.data;
                        staffDetailsFormik.setValues({
                            name: staffData?.name || '',
                            profile_image: staffData?.profile_image || null,
                            color: staffData?.color || '#463434',
                            email: staffData?.email || '',
                            job_role: staffData?.job_role || '',
                            staff_show_all_calendar: staffData?.staff_show_all_calendar || 0,
                            is_allow_full_calendar: staffData?.is_allow_full_calendar || 0,
                            is_allow_all_notes: staffData?.is_allow_all_notes || 0,
                            is_reception: staffData?.is_reception || 0,
                            id: staffData?.id,
                           // service_ids: staffData?.services || [],
                            category_ids: staffData?.categories || [],
                            menu_ids: staffData?.menus || [],
                            phone: staffData?.phone?.startsWith("+1")
                                ? staffData.phone.substring(2)
                                : staffData?.phone?.startsWith("+92")
                                    ? staffData.phone.substring(3)
                                    : staffData?.phone || '',
                            countryCode: staffData?.phone?.startsWith("+1")
                                ? '+1'
                                : staffData?.phone?.startsWith("+92")
                                    ? '+92'
                                    : '+1',

                        });
                    }
                } catch (error) {
                    console.error("Error fetching staff data:", error);
                }
            }
        };

        fetchStaffData();
    }, [params?.staff_id]);

    // Set working hours when data loads
    useEffect(() => {
        if (staffHours?.length) {
            const updatedHours = workingHoursFormik.values.hours.map((day) => {
                const staffHour = staffHours.find(sh => sh.day === day.day);
                return staffHour ? {
                    ...day,
                    start_time: staffHour?.start_time || "",
                    end_time: staffHour?.end_time || "",
                    is_off: staffHour?.is_off === 1 ? true : false,
                    per_day_appointments: staffHour?.per_day_appointments || 1
                } : day;
            });
            workingHoursFormik.setValues({ hours: updatedHours });
        }
    }, [staffHours]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (loading) return <Waveloading />;

    if (!clinicServicesStore?.services?.length) {
        return (
            <Grid container p={'20px'}>
                <Grid item xs={12} sx={{ display: 'flex', mt: '16px', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography sx={{ textAlign: 'center' }}>Please Add Services before</Typography>
                    <Link to={`/${user?.role_id === 2 ? "crm" : "admin"}/configuration/clinic/${params?.clinic_id}/add-service`} style={{ color: '#E01E5A', marginLeft: '7px' }}>Click here</Link>
                </Grid>
            </Grid>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            {/* <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}
            >
                <Tab label="Staff Details" />
                <Tab label="Categories" />
                {params?.staff_id && <Tab label="Working Hours" />}
                {params?.staff_id && <Tab label="Holidays" />}
                {params?.staff_id && <Tab label="Break Times" />}
            </Tabs> */}
            <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Back Arrow */}
                    <IconButton
                        sx={{ display: { xs: 'block', md: 'none' }, mr: 1 }}
                        onClick={() => setActiveTab((prev) => Math.max(prev - 1, 0))}
                    >
                        <KeyboardArrowLeftIcon sx={{mt:"-12px"}}/>
                    </IconButton>

                    {/* Tabs Component */}
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                            mb: {sm:3, xs:1},
                            flexGrow: 1,
                            overflow: 'auto',
                            '& .MuiTabs-scrollable': { display: 'flex' },
                            '& .MuiTabs-flexContainer': { display: 'flex' },
                            '& .MuiTab-root': { minWidth: 'auto' },
                        }}
                        scrollButtons="auto"
                        variant="scrollable"
                    >
                        <Tab label="Staff Details" />
                        {params?.staff_id && <Tab label="Categories" />}
                        {params?.staff_id && <Tab label="Working Hours" />}
                        {params?.staff_id && <Tab label="Holidays" />}
                        {params?.staff_id && <Tab label="Break Times" />}
                    </Tabs>

                    {/* Next Arrow */}
                    <IconButton
                        sx={{ display: { xs: 'block', md: 'none' }, ml: 1 }}
                        onClick={() => setActiveTab((prev) => Math.min(prev + 1, 4))} // Limit to max number of tabs
                    >
                        <KeyboardArrowRightIcon sx={{mt:"-15px"}}/>
                    </IconButton>
                </Box>
            </Box>

            {activeTab === 0 && (
                <form onSubmit={staffDetailsFormik.handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                            <Image
                                label={'Image'}
                                name={"profile_image"}
                                values={staffDetailsFormik.values}
                                errors={staffDetailsFormik.errors}
                                touched={staffDetailsFormik.touched}
                                setFieldValue={staffDetailsFormik.setFieldValue}
                            />
                            <CustomModal open={isOpen} setOpen={setIsOpen}>
                                <HexColorPicker
                                    color={staffDetailsFormik.values.color}
                                    onChange={(color) => staffDetailsFormik.setFieldValue('color', color)}
                                />
                            </CustomModal>
                            <FormLabel sx={labelStyle}>Legend Color</FormLabel>
                            <Box
                                onClick={() => setIsOpen(true)}
                                style={{
                                    cursor: 'pointer',
                                    marginTop: '10px',
                                    height: '35px',
                                    width: '35px',
                                    borderRadius: '5px',
                                    border: '1px solid #EDF2F7',
                                    backgroundColor: staffDetailsFormik.values?.color
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={9}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <FormInput
                                        name={"name"}
                                        label={"Name"}
                                        placeholder={"Type your name"}
                                        errors={staffDetailsFormik.errors}
                                        touched={staffDetailsFormik.touched}
                                        values={staffDetailsFormik.values}
                                        handleChange={staffDetailsFormik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormInput
                                        name={"email"}
                                        label={"Email"}
                                        placeholder={"Type your email"}
                                        errors={staffDetailsFormik.errors}
                                        touched={staffDetailsFormik.touched}
                                        values={staffDetailsFormik.values}
                                        handleChange={staffDetailsFormik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormInputPhone
                                        name={"phone"}
                                        label={"Phone"}
                                        setFieldTouched={staffDetailsFormik.setFieldTouched}
                                        placeholder={staffDetailsFormik.values?.countryCode === '+1' ? "xxx-xxx-xxxx" : "3xxxxxxxxx"}
                                        errors={staffDetailsFormik.errors}
                                        touched={staffDetailsFormik.touched}
                                        values={staffDetailsFormik.values}
                                        handleChange={staffDetailsFormik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormInput
                                        name={"job_role"}
                                        label={"Job Role"}
                                        placeholder={"Type your role"}
                                        errors={staffDetailsFormik.errors}
                                        touched={staffDetailsFormik.touched}
                                        values={staffDetailsFormik.values}
                                        handleChange={staffDetailsFormik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormPasswordInput
                                        name={"password"}
                                        label={"Set Password"}
                                        placeholder={""}
                                        errors={staffDetailsFormik.errors}
                                        touched={staffDetailsFormik.touched}
                                        values={staffDetailsFormik.values}
                                        handleChange={staffDetailsFormik.handleChange}
                                    />
                                </Grid>
                                {user?.role_id === 2 && (
                                    <Grid item xs={12} md={6}>
                                        <FormStatusInput
                                            name={"staff_show_all_calendar"}
                                            label={"Staff Show All Calendar"}
                                            errors={staffDetailsFormik.errors}
                                            row
                                            touched={staffDetailsFormik.touched}
                                            setFieldValue={staffDetailsFormik.setFieldValue}
                                            values={staffDetailsFormik.values}
                                            handleChange={staffDetailsFormik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {user?.role_id === 2 && (
                                    <Grid item xs={12} md={6}>
                                        <FormStatusInput
                                            name={"is_allow_full_calendar"}
                                            label={"Allow Full Calendar"}
                                            errors={staffDetailsFormik.errors}
                                            row
                                            touched={staffDetailsFormik.touched}
                                            setFieldValue={staffDetailsFormik.setFieldValue}
                                            values={staffDetailsFormik.values}
                                            handleChange={staffDetailsFormik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {user?.role_id === 2 && (
                                    <Grid item xs={12} md={6}>
                                        <FormStatusInput
                                            name={"is_allow_all_notes"}
                                            label={"Allow All Notes"}
                                            errors={staffDetailsFormik.errors}
                                            row
                                            touched={staffDetailsFormik.touched}
                                            setFieldValue={staffDetailsFormik.setFieldValue}
                                            values={staffDetailsFormik.values}
                                            handleChange={staffDetailsFormik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {user?.role_id === 2 && (
                                    <Grid item xs={12} md={6}>
                                        <FormStatusInput
                                            name={"is_reception"}
                                            label={"Reception"}
                                            errors={staffDetailsFormik.errors}
                                            row
                                            touched={staffDetailsFormik.touched}
                                            setFieldValue={staffDetailsFormik.setFieldValue}
                                            values={staffDetailsFormik.values}
                                            handleChange={staffDetailsFormik.handleChange}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>

                        {/*<Grid item xs={12}>*/}
                        {/*    <FormAutoComplete*/}
                        {/*        name={"service_ids"}*/}
                        {/*        options={clinicServicesStore?.services}*/}
                        {/*        values={staffDetailsFormik.values}*/}
                        {/*        multiple={true}*/}
                        {/*        errors={staffDetailsFormik.errors}*/}
                        {/*        touched={staffDetailsFormik.touched}*/}
                        {/*        label={"Service Associated"}*/}
                        {/*        setFieldValue={staffDetailsFormik.setFieldValue}*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {user?.role_id === 2 && (
                            <Grid item xs={12}>
                                <FormAutoComplete
                                    name={"menu_ids"}
                                    options={menus}
                                    values={staffDetailsFormik.values}
                                    multiple={true}
                                    errors={staffDetailsFormik.errors}
                                    touched={staffDetailsFormik.touched}
                                    label={"Menus Associated"}
                                    setFieldValue={staffDetailsFormik.setFieldValue}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 ,gap:"7px"}}>
                            <CustomButton
                                mainColor={'#ED1E45'}
                                val={'Cancel'}
                                handleClick={() => {
                                    navigate(`/${user?.role_id === 2 || user?.role_id === 4 ? "crm" : "admin"}/configuration/clinic/${params?.clinic_id}/staff`)
                                }}
                            />
                            <SubmitButton
                                val={params?.staff_id ? 'Update Staff' : 'Add Staff'}
                                sx={{ ml: 2 }}
                            />
                        </Grid>
                    </Grid>
                </form>
            )}

            {activeTab === 1 && (
                <Box sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ mb: 3 }}>Select Categories for {staffDetailsFormik.values.name}</Typography>

                    {clinicTreatmentGroupStore?.staffTreatmentGroups?.length > 0 ? (
                        <>
                            <List>
                                {renderCategories(clinicTreatmentGroupStore.staffTreatmentGroups)}
                            </List>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        // Prepare form data with updated categories
                                        const formData = new FormData();
                                        Object.keys(staffDetailsFormik.values).forEach(key => {
                                            if (key === 'category_ids') {
                                                staffDetailsFormik.values[key].forEach(value =>
                                                    formData.append('category_ids[]', value.id)
                                                );
                                            } else if (Array.isArray(staffDetailsFormik.values[key])) {
                                                staffDetailsFormik.values[key].forEach(value =>
                                                    formData.append(`${key}[]`, value?.id)
                                                );
                                            } else if (key === 'profile_image' &&
                                                typeof staffDetailsFormik.values[key] !== 'string') {
                                                formData.append(key, staffDetailsFormik.values[key]);
                                            } else if (key === 'countryCode' || key === 'phone') {
                                                formData.append(key,
                                                    `${staffDetailsFormik.values.countryCode}${staffDetailsFormik.values.phone}`
                                                );
                                            } else {
                                                formData.append(key, staffDetailsFormik.values[key]);
                                            }
                                        });
                                        formData.append("provider_id", params?.clinic_id);

                                        setLoading(true);
                                        dispatch(updateClinicsStaff({
                                            data: formData,
                                            provider_id: params?.clinic_id
                                        }))
                                            .then(res => {
                                                if (res?.payload?.success === 'true') {
                                                    // Show success message or handle as needed
                                                    //console.log("Categories updated successfully");
                                                }
                                                setLoading(false);
                                            });
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Updating...' : 'Update Categories'}
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <Typography>No categories available</Typography>
                    )}
                </Box>
            )}

            {activeTab === 2 && params?.staff_id && (
                <form onSubmit={workingHoursFormik.handleSubmit}>
                    <Box sx={{ p: {sm:3, xs:0} }}>
                        <Typography variant="h6" sx={{ mb: 3 }}>Set up weekly staff schedule for {staffDetailsFormik.values.name}</Typography>

                        {workingHoursFormik.values?.hours.map((item, index) => (
                            <Grid key={index} container sx={{ alignItems: 'center', width: "100%", py: 2 }}>
                                <Grid item lg={3} xs={6}>
                                    <FormLabel sx={{
                                        fontSize: { lg: "16px", xl: "16px", md: "16px", xs: "14px !important" },
                                        color: '#27272e!important',
                                        letterSpacing: '.3px',
                                        textTransform: 'capitalize'
                                    }}>
                                        {item?.day}
                                    </FormLabel>
                                </Grid>
                                <Grid item lg={1.5} xs={6} sx={{ display:{sm:'flex', xs:'flex', md:'unset'}, justifyContent:'end' }}>
                                    <FormControlLabel
                                        control={
                                            <IOSSwitch
                                                name={`hours[${index}].is_off`}
                                                sx={{ m: 1 }}
                                                checked={!item?.is_off}
                                                onChange={(e) => {
                                                    workingHoursFormik.handleChange({
                                                        target: { name: `hours[${index}].is_off`, value: !e.target?.checked },
                                                    });
                                                }}
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid item lg={7.5} xs={12}>
                                    <Grid container justifyContent={'space-around'}>
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                name={`hours[${index}].start_time`}
                                                options={createTimeSlots(item?.day)}
                                                getOptionLabel={(option) => option}
                                                value={item?.start_time}
                                                onChange={(event, value) => {
                                                    workingHoursFormik.setFieldValue(`hours.${index}.start_time`, value || "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder={'Start Time'} sx={inputStyle} />
                                                )}
                                                getOptionDisabled={(option) => option === item?.end_time}
                                            />
                                            {workingHoursFormik.errors.hours?.[index]?.start_time &&
                                                workingHoursFormik.touched.hours?.[index]?.start_time && (
                                                    <FormHelperText sx={{ color: '#CB3838', width: 'max-content', mx: 0 }}>
                                                        {workingHoursFormik.errors.hours?.[index]?.start_time}
                                                    </FormHelperText>
                                                )}
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                name={`hours[${index}].end_time`}
                                                options={createTimeSlots(item?.day)}
                                                getOptionLabel={(option) => option}
                                                value={item?.end_time}
                                                onChange={(event, value) =>
                                                    workingHoursFormik.setFieldValue(`hours.${index}.end_time`, value || "")
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder={'End Time'} sx={inputStyle} />
                                                )}
                                                getOptionDisabled={(option) => option === item?.start_time}
                                            />
                                            {workingHoursFormik.errors.hours?.[index]?.end_time &&
                                                workingHoursFormik.touched.hours?.[index]?.end_time && (
                                                    <FormHelperText sx={{ color: '#CB3838', width: 'max-content', mx: 0 }}>
                                                        {workingHoursFormik.errors.hours?.[index]?.end_time}
                                                    </FormHelperText>
                                                )}
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    fullWidth
                                                    name={`hours[${index}].per_day_appointments`}
                                                    type={"number"}
                                                    InputProps={{
                                                        inputProps: { min: 0 }
                                                    }}
                                                    sx={{ ...inputStyle }}
                                                    placeholder={"per day appointment"}
                                                    value={item?.per_day_appointments}
                                                    onChange={workingHoursFormik.handleChange}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}

                        <Grid item xs={12} sx={{ display: 'flex', mt: 2, justifyContent: "flex-end" }}>
                            <Button
                                sx={{
                                    backgroundColor: '#09ABF1',
                                    borderColor: '#09ABF1',
                                    color: '#fff',
                                    ml: 3,
                                    height: '44px',
                                    "&:hover": {
                                        color: '#09ABF1',
                                        borderColor: '#09ABF1',
                                    }
                                }}
                                type={"submit"}
                                variant={'outlined'}
                            >
                                Save Staff Schedule
                            </Button>
                        </Grid>
                    </Box>
                </form>
            )}

            {activeTab === 3 && params?.staff_id && (
                <StaffHoliday
                    setLoading={setLoading}
                    staff_id={params?.staff_id}
                    staffHolidays={staffHolidays}
                />
            )}

            {activeTab === 4 && params?.staff_id && (
                <StaffBreakTime
                    setLoading={setLoading}
                    staff_id={params?.staff_id}
                    staffBreakTimes={staffBreakTimes}
                />
            )}
        </Box>
    );
};

export default AddStaff;